export default __webpack_public_path__ + "static/media/offer-4.5cd619e1.jpg";